<template>
  <div class='press-result'>
    <h2></h2>
    <div v-if='!issecc'class='content'>
      <div v-loading='loading' class='table-wrapper'>
        <!-- 列表 -->
        <ul>
        
        <li>
          <div class='cell'>
            <span class='label'>征订学校:</span>
            <input v-model='form.solicit_school' type='text' class='input' placeholder='请输入'>
          </div>
          </li>
        <li>
          <div class='cell'>
            <span class='label'>征订院系:</span>
            <input v-model='form.solicit_faculty' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>征订班级:</span>
            <input v-model='form.solicit_class' type='text' class='input' placeholder='请输入'>
          </div>
          </li>
        <li>
          <div class='cell'>
            <span class='label'>征订人:</span>
            <input v-model='form.solicit_user' type='text' class='input' placeholder='请输入'>
          </div>
          </li>
        <li>
          <div class='cell'>
            <span class='label'>发货地址:</span>
            <input v-model='form.solicit_shipAddress' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>联系方式:</span>
            <input v-model='form.solicit_contact' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
      </ul>
      <a href='javascript:;' class='btn-search' @click='submitOrder'>确认订单信息</a>
      </div>
    </div>
    <div v-else>
    <a href='javascript:;' class='btn-search succeed' style="margin-top:100px">订单已提交成功，</a>
    <p class='btn-search succeed'>我们会第一时间处理</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      issecc:false,
      form:{
      	solicit_school:'',
      	solicit_faculty:'',
      	solicit_class:'',
      	solicit_user:'',
      	solicit_shipAddress:'',
      	solicit_contact:'',
      }
    }
  },

  methods: {
  	submitOrder(){
  		this.loading = true;
  		setTimeout(()=>{
  			this.loading = false;
  			this.issecc = true
  		},1000)

  	}
   }
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.content {
    width: 1200px;
    height: 730px;
    background: @blue-l;
    margin: 34px auto;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding: 35px 150px;

    .search-wrapper {
      width: 440px;
      height: 30px;
      position: relative;
      margin: 0 auto;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 10px;
      border: 1px solid #999;
      border-radius: 5px;

      .input-search {
        flex: 1;
        outline: none;
        border: none;
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        padding: 0 10px;
      }

      i {
        font-size: 20px;
        color: #999;
        &.icon-close {
          color: #00c36b;
          cursor: pointer;
        }
      }
    }

    ul {
      margin-top: 57px;
      display: flex;
      flex-direction: column;
      align-items: center;

      li {
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 23px;

        .cell {
          flex: 1;
          height: 30px;
          margin: 0 40px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          font-size: 10px;
          color: #000000;

          .label {
            display: inline-block;
            width: 100px;
            text-align: end;
            font-size: 14px;
          }

          .input {
            flex: 1;
            height: 28px;
            outline: none;
            border: none;
            margin-left: 5px;
            border-radius: 3px;
            font-size: 14px;
            text-indent: 5px;
          }
        }
      }
    }

    .btn-search {
      display: block;
      width: 250px;
      height: 40px;
      text-align: center;
      font-size: 20px;
      color: #fff;
      line-height: 40px;
      border-radius: 5px;
      background: @blue-d;
      margin: 40px auto 0;
    }
    .succeed{
    	color: #000;
    	background: #fff;
    }
  }

</style>




// WEBPACK FOOTER //
// src/pages/PressSubmit.vue